export default __webpack_public_path__ + "static/media/rifles-2.cf6db54c.svg";